__turbopack_context__.v({
  "eyebrow": "AIMLServicesCardSection-module__eV-ADq__eyebrow",
  "section": "AIMLServicesCardSection-module__eV-ADq__section",
  "title": "AIMLServicesCardSection-module__eV-ADq__title",
});
